import Super from '@simplepractice/ember-messaging-client/serializers/messaging-base';

export default Super.extend({});
